import type { Dayjs } from 'dayjs';
import { DateCalendar } from '@mui/x-date-pickers/DateCalendar';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

interface DateCalendarBaseProps {
  value: Dayjs | null;
  onChange: (date: Dayjs) => void;
  disablePast?: boolean;
}

export function DateCalendarBase({ value, onChange, disablePast = false }: DateCalendarBaseProps) {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DateCalendar disablePast={disablePast} value={value} onChange={onChange} sx={{ border: '1px solid #E0E0E0', borderRadius: 2 }} />
    </LocalizationProvider>
  );
}
